import React from 'react';
import { cn } from '../lib/utils';

export function StatusIndicator({
  className,
  color = 'emerald',
  pulse = true,
  ...props
}) {
  const colorMap = {
    emerald: 'text-emerald-500 bg-emerald-500',
    rose: 'text-rose-500 bg-rose-500',
    amber: 'text-amber-500 bg-amber-500',
    sky: 'text-sky-500 bg-sky-500',
    zinc: 'text-zinc-400 bg-zinc-400',
    blue: 'text-blue-500 bg-blue-500',
  };

  const selectedColor = colorMap[color] || colorMap.emerald;

  return (
    <span
      className={cn(
        'relative inline-flex h-2 w-2 shrink-0 items-center justify-center rounded-full',
        className
      )}
      {...props}
    >
      {pulse && (
        <span
          className={cn(
            'absolute inset-0 rounded-full opacity-75 animate-ping',
            selectedColor.split(' ')[1]
          )}
          aria-hidden="true"
        />
      )}
      <span
        className={cn(
          'relative inline-flex h-1.5 w-1.5 rounded-full',
          selectedColor.split(' ')[1]
        )}
        aria-hidden="true"
      />
    </span>
  );
}

export default StatusIndicator;
